import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { PremiumCard, dashboardTokens } from "./dashboardStyles";

const FIELD_LABELS = {
  imovelInfo: "informações do imóvel",
  caracteristicas: "características",
  informacoesComerciais: "informações comerciais",
  informacoesAdicionais: "informações adicionais",
  imagesLinks: "fotos",
  ownerInfo: "dados do proprietário",
  selectedItems: "comodidades",
};

function formatWhen(timestamp) {
  const d = new Date(timestamp);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = d.toDateString() === yesterday.toDateString();

  const time = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  if (sameDay) return `Hoje ${time}`;
  if (isYesterday) return `Ontem ${time}`;
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) + ` ${time}`;
}

/**
 * Atividade recente derivada de /logs — o ÚNICO nó de auditoria realmente
 * escrito hoje, e só na edição de imóvel (EditImovel.js). Não há log de
 * criação, exclusão ou mudança de status, então o feed mostra apenas
 * edições reais — nada é inferido a partir de outro campo.
 */
function ActivityFeed({ entries }) {
  if (!entries.length) {
    return (
      <PremiumCard sx={{ p: 3 }}>
        <Typography sx={{ fontSize: "0.85rem", color: dashboardTokens.textSecondary }}>
          Nenhuma edição registrada recentemente.
        </Typography>
      </PremiumCard>
    );
  }

  return (
    <PremiumCard>
      <Stack divider={<Box sx={{ borderBottom: `1px solid ${dashboardTokens.border}` }} />}>
        {entries.map((e) => {
          const fieldLabels = e.fields.map((f) => FIELD_LABELS[f] || f).join(", ");
          return (
            <Box key={`${e.timestamp}-${e.codigo}`} sx={{ px: 2, py: 1.4 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={1}>
                <Typography sx={{ fontSize: "0.85rem", color: "#1e1e1e" }}>
                  Imóvel <strong>#{e.codigo}</strong> editado
                </Typography>
                <Typography sx={{ fontSize: "0.72rem", color: dashboardTokens.textSecondary, flexShrink: 0 }}>
                  {formatWhen(e.timestamp)}
                </Typography>
              </Stack>
              {fieldLabels && (
                <Typography sx={{ fontSize: "0.76rem", color: dashboardTokens.textSecondary, mt: 0.25 }}>
                  Alterado: {fieldLabels}
                </Typography>
              )}
            </Box>
          );
        })}
      </Stack>
    </PremiumCard>
  );
}

export default ActivityFeed;
